import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Index from '@/views/Index.vue'
import LocalStorageService from "@/common/LocalStorageService";

const localStorageService = LocalStorageService.getService();

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      meta: {
        requiresAuth: false
      },
      component: Index
    },

    {
      path: '/home',
      name: 'home',
      meta: {
        requiresAuth: true
      },
      component: Home
    },

    {
      path: '/timeout',
      name: 'timeout',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/Timeout.vue')
    },

    {
      path: '/faq',
      name: 'frequently-asked-questions',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/FAQ.vue')
    },

    {
      path: '/terms-of-service',
      name: 'tos',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/TermsOfService.vue')
    },

    {
      path: '/cart',
      name: 'cart',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/checkout/Cart.vue')
    },

    {
      path: '/checkout',
      name: 'checkout',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/checkout/Checkout.vue')
    },

    {
      path: '/orders',
      name: 'orders',
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/user/Orders.vue')
    },

    {
      path: '/product-select',
      name: 'product-select',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/product/ProductSelect.vue')
    },

    {
      path: '/receipt/:orderNumber',
      name: 'receipt',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/checkout/Receipt.vue')
    },

    // {
    //   path: '/death-select',
    //   name: 'death-select',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/death/DeathSelect.vue')
    // },
    //
    // {
    //   path: '/death-noncertified',
    //   name: 'death-noncertified',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/death/Noncertified.vue')
    // },
    //
    // {
    //   path: '/death-certified-cod',
    //   name: 'death-certified-cod',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/death/CertifiedCauseOfDeath.vue')
    // },
    //
    // {
    //   path: '/death-certified',
    //   name: 'death-certified',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/death/Certified.vue')
    // },
    //
    // {
    //   path: '/death-va',
    //   name: 'death-va',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/death/Veterans.vue')
    // },

    {
      path: '/birth-select',
      name: 'birth-select',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/product/birth/BirthSelect.vue')
    },

    {
      path: '/birth-certified',
      name: 'birth-certified',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/product/birth/Certified.vue')
    },

    // {
    //   path: '/birth-noncertified',
    //   name: 'birth-noncertified',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/birth/Noncertified.vue')
    // },
    //
    // {
    //   path: '/birth-noncertified-image',
    //   name: 'birth-noncertified-image',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/birth/Image.vue')
    // },
    //
    // {
    //   path: '/birth-verification',
    //   name: 'birth-verification',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/birth/Verification.vue')
    // },
    //
    // {
    //   path: '/birth-noncertified-original',
    //   name: 'birth-noncertified-original',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/birth/NoncertifiedOriginal.vue')
    // },
    //
    // {
    //   path: '/birth-noncertified-adopted',
    //   name: 'birth-noncertified-adopted',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/birth/NoncertifiedAdopt.vue')
    // },
    //
    // {
    //   path: '/birth-noncertified-health',
    //   name: 'birth-noncertified-health',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/birth/NoncertifiedHealth.vue')
    // },
    //
    //
    // {
    //   path: '/birth-change-summary',
    //   name: 'birth-change-summary',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/birth/ChangeSummary.vue')
    // },
    //
    // {
    //   path: '/birth-homeless',
    //   name: 'birth-homeless',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/birth/Homeless.vue')
    // },
    //
    // {
    //   path: '/birth-va',
    //   name: 'birth-va',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/birth/Veterans.vue')
    // },

    {
      path: '/data-select',
      name: 'data-select',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/product/data/DataSelect.vue')
    },

    {
      path: '/data-product-birth',
      name: 'data-product-birth',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/product/data/DataProductBirth.vue')
    },

    {
      path: '/data-product-death',
      name: 'data-product-death',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/product/data/DataProductDeath.vue')
    },

    // {
    //   path: '/stillbirth-select',
    //   name: 'stillbirth-select',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/stillbirth/StillbirthSelect.vue')
    // },
    // {
    //   path: '/stillbirth-noncertified-health',
    //   name: 'stillbirth-noncertified-health',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/stillbirth/StillbirthHealth.vue')
    // },
    // {
    //   path: '/stillbirth-noncertified',
    //   name: 'stillbirth-noncertified',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/stillbirth/StillbirthLegal.vue')
    // },
    // {
    //   path: '/stillbirth-certified',
    //   name: 'stillbirth-certified',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/stillbirth/StillbirthCertified.vue')
    // },
    //
    // {
    //   path: '/mfar-select',
    //   name: 'mfar-select',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/mfar/MfarSelect.vue')
    // },
    //
    // {
    //   path: '/mfar-search',
    //   name: 'mfar-search',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/mfar/MfarSearch.vue')
    // },
    //
    // {
    //   path: '/parentage-select',
    //   name: 'parentage-select',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/parentage/ParentageSelect.vue')
    // },
    //
    // {
    //   path: '/parentage-rop-revocation ',
    //   name: 'parentage-rop-revocation',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/parentage/ParentageRevocation.vue')
    // },
    //
    // {
    //   path: '/parentage-recognition',
    //   name: 'parentage-recognition',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/parentage/ParentageRecognition.vue')
    // },
    //
    // {
    //   path: '/parentage-snps-revocation',
    //   name: 'parentage-snps-revocation',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/parentage/SpouseRevocation.vue')
    // },
    //
    // {
    //   path: '/parentage-snps',
    //   name: 'parentage-snps',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/parentage/SpouseStatement.vue')
    // },
    //
    // {
    //   path: '/change-select',
    //   name: 'change-select',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/amendments/ChangeSelect.vue')
    // },
    //
    // {
    //   path: '/amendment-birth',
    //   name: 'amendment-birth',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/amendments/BirthAmendment.vue')
    // },
    //
    // {
    //   path: '/amendment-birth-certificate',
    //   name: 'amendment-birth-certificate',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/amendments/BirthAmendmentCertificate.vue')
    // },
    //
    // {
    //   path: '/amendment-death',
    //   name: 'amendment-death',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/amendments/DeathAmendment.vue')
    // },
    //
    // {
    //   path: '/amendment-death-certificate',
    //   name: 'amendment-death-certificate',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/amendments/DeathAmendmentCertificate.vue')
    // },
    //
    // {
    //   path: '/replacement-birth-court-order',
    //   name: 'replacement-birth-court-order',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/amendments/BirthReplacementCourtOrder.vue')
    // },
    //
    // {
    //   path: '/replacement-birth-court-order-certificate',
    //   name: 'replacement-birth-court-order-certificate',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/amendments/BirthReplacementCourtOrderCertificate.vue')
    // },
    //
    // {
    //   path: '/replacement-birth-paternity',
    //   name: 'replacement-birth-paternity',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/amendments/BirthReplacementPaternity.vue')
    // },
    //
    // {
    //   path: '/replacement-birth-paternity-certificate',
    //   name: 'replacement-birth-paternity-certificate',
    //   meta: {
    //     requiresAuth: false
    //   },
    //   component: () => import(/* webpackChunkName: "timeout" */ './views/product/amendments/BirthReplacementPaternityCertificate.vue')
    // },

    {
      path: '/attestation',
      name: 'attestation',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './components/checkout-wizard/Attestation.vue')
    },

    {
      path: '/notarize',
      name: 'notarize',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './components/checkout-wizard/Notarize.vue')
    },

    {
      path: '/documents',
      name: 'documents',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './components/checkout-wizard/Documents.vue')
    },

    {
      path: '/summary',
      name: 'summary',
      meta: {
        requiresAuth: false
      },
      component: () =>import('./components/checkout-wizard/OrderSummary.vue')
    },

    {
      path: '/shipping-info',
      name: 'shipping-info',
      meta: {
        requiresAuth: false
      },
      component: () =>import('./components/checkout-wizard/ShippingInformation.vue')
    },

    {
      path: '/customer-information',
      name: 'customer-information',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './components/checkout-wizard/CustomerInformation.vue')
    },

    {
      path: '/register/:redirect?',
      name: 'register',
      meta: {
        requiresAuth: false,
        forbidAuth: true,
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/user/Register.vue')
    },

    {
      path: '/coversheet',
      name: 'coversheet',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/product/amendments/Coversheet.vue')
    },

    {
      path: "/thanks",
      name: 'thanks',
      meta: {
        requiresAuth: false,
      },
      component: () => import(/* webpackChunkName: "thanks" */ './views/Thanks.vue')
    },

    {
      path: '/unauthorized',
      name: 'unauthorized',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "unauthorized" */ './views/Unauthorized.vue')
    },

    {
      path: '*', 
      component: Home
    },

    {
      path: '/ieNotification',
      name: 'ieNotification',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "unauthorized" */ './views/IeNotification.vue')
    },
  ]
})

router.beforeEach((to, from, next) => {
  if(navigator.userAgent.match(/msie|trident/i) && to.name !== "ieNotification") {
    router.push("ieNotification")
  }
  if (to.matched.some(record => record.meta.forbidAuth)) {
    if (router.app.$keycloak && router.app.$keycloak.authenticated) {
      router.push('home')
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (router.app.$keycloak && router.app.$keycloak.authenticated) {
      if (to.meta.authRoles) {
        let hasRole = false
        for (var i = 0; i < to.meta.authRoles.length; i++) {
          if (router.app.$keycloak.hasResourceRole(to.meta.authRoles[i])) {
            hasRole = true;
          }
        }
        if (hasRole) {
          next()
        } else {
          router.push('unauthorized') 
        }
      } else {
        next();
      }
    } else {
      const url = localStorageService.getLoginUrl()
      window.location.replace(url)
    }
  } else {
    next()
  }
})

export default router
